import React from 'react';
import { oohData } from '../utils/oohData';
import { EyeIcon, ClockIcon } from 'lucide-react';
const VERDICT_STYLES: Record<string, string> = {
  weak: 'bg-red-100 text-red-800 border-red-200',
  moderate: 'bg-amber-100 text-amber-800 border-amber-200',
  strong: 'bg-green-100 text-green-800 border-green-200'
};
export const ViewingContext: React.FC = () => {
  const {
    viewingContext
  } = oohData;
  return <div className="bg-white rounded-xl shadow-sm border-l-4 border-l-[#1E3A8A] overflow-hidden" data-id="element-328" data-mp="37b4gp6bmjken">
      <div className="p-6" data-id="element-329" data-mp="32c08oj0frspw">
        <div className="flex items-center space-x-2 mb-3" data-id="element-330" data-mp="32ct6uvlbx9wf">
          <EyeIcon className="export-icon-down w-5 h-5 text-[#1E3A8A]" data-id="element-331" data-mp="3gazxprrv29ml" />
          <h3 className="font-semibold text-gray-900" data-id="element-332" data-mp="3c960xuksdprp">Viewing Context</h3>
        </div>
        <p className="text-sm text-gray-700 leading-relaxed" data-id="element-333" data-mp="3cbir2v0p76fu">
          {viewingContext.description}
        </p>

        {/* Pays off the three viewing modes with a verdict per mode, which is
            where the central tension of this creative actually shows. */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-5" data-id="element-334" data-mp="2q3hjx0ltz4d8">
          {viewingContext.modes.map(mode => <div key={mode.label} className="bg-gray-50/50 border border-gray-100 rounded-xl p-4" data-id="element-335" data-mp="2v56ygq89i062">
              <div className="flex items-center justify-between mb-2 gap-2" data-id="element-336" data-mp="344afzprs67ig">
                <div className="flex items-center space-x-2 min-w-0" data-id="element-337" data-mp="27di1gwkhwnis">
                  <ClockIcon className="export-icon-down w-4 h-4 text-gray-400 flex-shrink-0" data-id="element-338" data-mp="27fclm8ny0blt" />
                  <span className="text-xs font-semibold text-gray-900 uppercase tracking-wider" data-id="element-339" data-mp="2bfd0tviv8qtx">
                    {mode.label}
                  </span>
                  <span className="text-xs text-gray-500" data-id="element-340" data-mp="2l56aus3d0xw2">{mode.time}</span>
                </div>
                <span className={`export-text-up inline-flex items-center flex-shrink-0 px-2.5 py-1 rounded-full text-xs font-semibold border capitalize ${VERDICT_STYLES[mode.verdict]}`} data-id="element-341" data-mp="1nq23yp4mzgl2">
                  {mode.verdict}
                </span>
              </div>
              <p className="text-xs text-gray-600 leading-relaxed" data-id="element-342" data-mp="2r0y6t5wh34sn">
                {mode.note}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
};